module.exports = __webpack_public_path__ + "assets/img/ic-grayball.61aa9d86.svg";